export default class UserProduct {
  productTypeId;
  sizeId;
  optionId;
    bgFlossId; //todo: should this be tracked as backgroundcolorflossid?
    bgImageId;
  motifs; //array of ProductMotif
    productLocation;
    kitId;
    originKitId;
    finishStep;
    motifSpacing;


  constructor(jsonData) {
    Object.assign(this, jsonData);
  }
}
